<template>
    <div><img src="../assets/drtt.jpg" class="col-12"></div>
    <div class="mx-5 mt-3">
        <h4 class="leftfont title"><label>{{ $t('dr.TTForm') }}</label></h4>
        <div class="mt-3 description"><label>{{ $t('formDescription') }}</label></div>
        <div class="description mt-3"><p>{{$t('activity')}}<br>{{ $t('cost') }}<br>{{ $t('connection') }}{{ '(07-9761588#1124,' }}<a href="#">{{ ' palm33123@tongtai.com.tw ' }}</a>{{ ')' }}</p></div>
        <!-- <div class="description "><p>{{ $t('connection') }}</p></div> -->
    </div>
</template>
<script setup>
</script>